/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Processing_PillInputs */



/**
* | output |
* | --- |
* | "Report on its way" |
*
* @param {Meeting_Offline_Processing_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_processing_pill = /** @type {((inputs?: Meeting_Offline_Processing_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Processing_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verslag onderweg")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte rendu en route")
	return /** @type {LocalizedString} */ ("Report on its way")
});